import { createSlice } from '@reduxjs/toolkit';
const initialState = {};
const optimizationOptionSlice = createSlice({
  name: 'optimizationOptionData',
  initialState: {
    selectedOptions: {},
  },
  reducers: {
    setselectedOptions: (state, action) => {
      state.selectedOptions = action.payload;
    },
    removeSelectedOptions: (state) => {
      state.selectedOptions = initialState;
    },
  },
});
export const { setselectedOptions } = optimizationOptionSlice.actions;
export default optimizationOptionSlice.reducer;
